import { useRockyContext } from "../context/useRockyContext";
import { Envs } from "../enums/envs";

export const useAuthFetch = () => {
  const { token, env } = useRockyContext();

  const fetchWithAuth = async (url: string) => {
    if (!token) {
      throw new Error("No token found");
    }

    const response = await fetch(
      (env === Envs.local
        ? "http://localhost:8080/"
        : `https://${
            env === Envs.prod ? "rockyemail" : "rockyemail-dev"
          }.agileengine.com/`) + url,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    return response.json();
  };

  return fetchWithAuth;
};
